export default "__VITE_PUBLIC_ASSET__c63c37c3__"